import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import QRCode from 'qrcode';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        let variableCopy = parsedParameters['variableObject'];
        if(parsedParameters.error){
            variableCopy[variableName] = {
                error : {
                    message : 'Failed to parse function parameters.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let resolvedParams = parsedParameters['accumulator'];
        let options = {};
        if(resolvedParams['type']){
            options['type'] = resolvedParams['type'];
        }
        if(resolvedParams['quality']){
            options['quality'] = resolvedParams['quality'];
        }
        if(resolvedParams['margin']){
            options['margin'] = resolvedParams['margin'];
        }
        if(resolvedParams['scale']){
            options['scale'] = resolvedParams['scale'];
        }
        if(resolvedParams['darkColor']){
            if(!options['color']){
                options['color'] = {};
            }
            options['color']['dark'] = resolvedParams['darkColor'];
        }
        if(resolvedParams['lightColor']){
            if(!options['color']){
                options['color'] = {};
            }
            options['color']['light'] = resolvedParams['lightColor'];
        }
        if(resolvedParams['width']){
            options['width'] = resolvedParams['width'];
        }

        if(!resolvedParams['text']){
            variableCopy[variableName] = {
                error : {
                    message : 'Text is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Text is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let qrCode = await QRCode.toDataURL(resolvedParams['text'], options);
        variableCopy[variableName] = qrCode;
        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy,
            hasError : false,
            errorPayload : undefined
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/generateQrCodeParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}